import type { CreateRetractationReturnRequestDto, ReturnRequestDto } from "../generated/schema";
import { getPublicAuthHeader, getReturnWidgetFetchClient } from "./return-widget-client";
import { usePublicApiMutation } from "./use-public-api-mutation";

export async function publicCreateRetractationReturnRequest(
	body: CreateRetractationReturnRequestDto,
): Promise<ReturnRequestDto> {
	const { data, error } = await getReturnWidgetFetchClient().POST(
		"/public/return-request/retractation",
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		{ params: { header: getPublicAuthHeader() }, body: body as any },
	);
	if (error) throw error;
	return data as ReturnRequestDto;
}

export function usePublicCreateRetractationReturnRequest() {
	return usePublicApiMutation(
		"post",
		"/public/return-request/retractation",
		{
			mapVariables: (body: CreateRetractationReturnRequestDto) => ({
				params: { header: getPublicAuthHeader() },
				body,
			}),
		},
	);
}
